export const EShapeActionValueBlinkType = wcardinal.ui.EShapeActionValueBlinkType;